import { useSelector } from "react-redux";

const useUserLoginType = () => {
   return useSelector(
    (state) => state.auth?.user?.user_login_type || null
  );
};

export default useUserLoginType;